// Core Imports
import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'

// Module Imports
import { adminUsersEndpoints } from '@/modules/admin/admin.constants'
import type {
  TAdminUser,
  TCreateAdminUserRequest,
  TUpdateAdminUserRolesRequest,
} from '@/modules/admin/admin.types'

export async function getAdminUsersList(): Promise<TAdminUser[]> {
  const response = await api.get<TResponse<TAdminUser[]>>(
    adminUsersEndpoints.list
  )

  return response.data.data
}

export async function getAdminUserDetail(id: string): Promise<TAdminUser> {
  const response = await api.get<TResponse<TAdminUser>>(
    adminUsersEndpoints.detail(id)
  )
  return response.data.data
}

export async function createAdminUser(
  payload: TCreateAdminUserRequest
): Promise<string> {
  const response = await api.post<string>(adminUsersEndpoints.create, payload)
  return response.data
}

export async function deleteAdminUser(id: string): Promise<void> {
  await api.delete<null>(adminUsersEndpoints.delete(id))
}

export async function updateAdminUserRoles(
  payload: TUpdateAdminUserRolesRequest
): Promise<TAdminUser> {
  const { user_id, role_ids } = payload
  const response = await api.put<TResponse<TAdminUser>>(
    adminUsersEndpoints.edit(user_id),
    { role_ids }
  )

  return response.data.data
}
